import { PackageTypeSelect } from '@frontend/package/select';
import { PackageType } from '@frontend/package/types';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import usePackageTypeConstraintDataInput from './package-type-constraint-data-input.controller';

const ID = 'package-type-constraint-data-input';

export interface PackageTypeConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const PackageTypeConstraintDataInput = (props: PackageTypeConstraintDataInputProps) => {
    const viewProps = usePackageTypeConstraintDataInput(props);

    return (
        <PackageTypeSelect
            id={ID}
            required
            value={viewProps.formValues?.type as PackageType ?? null}
            onSelect={(v) => {
                props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { type: v.value } : undefined }));
            }}
        />
    );
};

export default PackageTypeConstraintDataInput;
